import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  wrapper: {
    maxWidth: 899,
    minWidth: 899,
    minHeight: 1150,
    maxHeight: 1150,
    padding: 64,
    paddingBottom: 161,

    position: 'relative',
    zIndex: 1,
  },
  textGenerated: {
    color: '#404040',
    fontSize: '10px',
    fontWeight: 400,
    lineHeight: '12px',
    letterSpacing: '0.4px',
  },
  logoPlatform: {
    height: 48,
    marginLeft: '-19px',
    display: 'block',
  },
  cornerTopLeft: {
    position: 'absolute',
    top: 201,
    left: 84,
    zIndex: -10,
  },
  cornerTopRight: {
    position: 'absolute',
    top: 207,
    right: 98,
    zIndex: -10,
  },
  cornerBottomRight: {
    position: 'absolute',
    bottom: 262,
    right: 96,
    zIndex: -10,
  },
  cornerBottomLeft: {
    position: 'absolute',
    bottom: 264,
    left: 99,
    zIndex: -10,
  },
  line: {
    width: '100%',
    height: 49,
    background: '#F5F5F5',
    position: 'absolute',
    top: '50%',
    left: 0,
    transform: 'translateY(-50%)',
    zIndex: -10,
  },
  text_certificate_page_2: {
    color: '#404040',
    fontFamily: 'Readex Pro',
    fontSize: 10,
    fontStyle: 'normal',
    fontWeight: 300,
    lineHeight: '12px',
    letterSpacing: 0.4,

    position: 'absolute',
    top: '50%',
    left: '-120px',
    transform: 'translateY(-50%) rotate(270deg)',
    zIndex: -9,
  },
}));

export default useStyles;
